<template>
    <div id="container" type="vdpp">
        <div class="page page-valuation" v-ga:request="{pageType:'vhomeWorth', state: {}}" v-ga:page="{pageType:'vhomeWorth', glb: glb, state: {}}">
            <mvtHeader />
            <valuationWelcome></valuationWelcome>

            <valuationCard></valuationCard>

            <section class="inline large">
                <div class="grid gap-3 fixed fixed-max-sm xs-grid-cols-1">
                    <div class="text-center">
                        <h2><b class="f3 text-bold">Frequently Asked Questions</b></h2>
                    </div>
                    <mvtFaq v-if="faqQuery" :query="faqQuery"></mvtFaq>
                </div>
            </section>

            <section class="inline large" id="agentFaqPanel">
                <div class="grid gap-3 xs-grid-cols-1 fixed fixed-max-sm">
                    <div class="text-center inline">
                        <h2><div class="f3 text-bold"> Maximize your sale price with the help of a Movoto network agent.</div></h2>
                    </div>
                    <valuationHotlead></valuationHotlead>
                </div>
            </section>
            <mvtFooter />
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-valuation.js"></script>
